import * as request from 'services/request'

export const actionTypes = {
  USERS_RECEIVED: 'USERS_RECEIVED'
}

export const usersReceived = users => ({
  type: actionTypes.USERS_RECEIVED,
  payload: users
})

export function getUsers () {
  return async dispatch => {
    const response = await request.authorized('/users')
    const users = await response.json()

    dispatch(usersReceived(users))
  }
}



// WEBPACK FOOTER //
// ./src/components/with-users/container/actions.js